import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { rootStore, stickyStore } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import AppRouter from "./router";
import "./index.css";
import Bowser from "bowser";
import BrowserSplash from "./components/__shared__/BrowserSplash";
import { MINIMUM_CHROME_VERISON } from "./constants";
import { Auth0Provider } from "@auth0/auth0-react";

class Index extends Component {
    isSupportedBrowser() {
        let parsedResult = Bowser.parse(window.navigator.userAgent);
        let browser = parsedResult.browser;
        let platform = parsedResult.platform;
        let userAgent = window.navigator.userAgent;

        // Check if it's Edge browser
        const isEdge =
            browser.name === "Microsoft Edge" || browser.name === "Edge";

        // Check if it's Chromium-based Edge (has "Edg/" in user agent, not "Edge/")
        const isChromiumEdge =
            isEdge &&
            userAgent.indexOf("Edg/") !== -1 &&
            userAgent.indexOf("Edge/") === -1;

        return (
            (browser.name === "Chrome" ||
                browser.name === "Chromium" ||
                // Only allow Chromium-based Edge
                isChromiumEdge) &&
            parseInt(browser.version) >= MINIMUM_CHROME_VERISON &&
            platform.type === "desktop"
        );
    }

    render() {
        if (this.isSupportedBrowser()) {
            return (
                <Auth0Provider
                    domain={import.meta.env.VITE_AUTH0_DOMAIN}
                    clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
                    authorizationParams={{
                        redirect_uri: window.location.origin,
                        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
                    }}
                >
                    <Provider store={rootStore}>
                        <PersistGate loading={null} persistor={stickyStore}>
                            <AppRouter />
                        </PersistGate>
                    </Provider>
                </Auth0Provider>
            );
        } else {
            return <BrowserSplash />;
        }
    }
}

ReactDOM.render(<Index />, document.getElementById("root"));
